import { useExpandedRowKeys } from '@/hooks';
import {
  type FC,
  type PropsWithChildren,
  createContext,
  useContext,
} from 'react';

const ExpandedRowKeysContext = createContext<
  ReturnType<typeof useExpandedRowKeys> | undefined
>(undefined);

export const useExpandedRowKeysContext = () => {
  const context = useContext(ExpandedRowKeysContext);

  if (!context) {
    throw Error(
      'useExpandedRowKeysContext must be used within ExpandedRowKeysProvider.',
    );
  }

  return context;
};

export const ExpandedRowKeysProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const value = useExpandedRowKeys();

  return (
    <ExpandedRowKeysContext.Provider value={value}>
      {children}
    </ExpandedRowKeysContext.Provider>
  );
};
